import request from 'tools/request'

const apiUrl = `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/radius-operation/`

const updateCompanyRadiusDefaults = async (
  payload: {
    radius1: number
    radius2: number
    radius3: number
    radius4: number
  },
  useKilometers = false
) => {
  const res = await request.put(`${apiUrl}company-defaults`, payload, {
    params: { useKilometers },
  })
  return res.data
}

export { updateCompanyRadiusDefaults }
